import { useQuery, NetworkStatus, QueryHookOptions, DocumentNode, OperationVariables } from '@apollo/client';

export const useQueryCacheAndNetwork = <TData, TVariables extends OperationVariables>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables>,
) => {
  const result = useQuery<TData, TVariables>(query, {
    ...options,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const { data, loading, networkStatus, error } = result;

  return {
    ...result,
    isInitialLoading: networkStatus === NetworkStatus.loading,
    isRefetching: networkStatus === NetworkStatus.refetch,
    isUpdating: networkStatus === NetworkStatus.setVariables,
    isFetching: networkStatus === NetworkStatus.fetchMore,
    hasData: Boolean(data),
    networkStatus,
    isBackgroundLoading: loading && Boolean(data),
    error,
  };
};
